// Black Rose Lounge — brand + media assets
export const LOGO = "/logo.png";
export const INSTAGRAM = "https://instagram.com/Black_Rose_DMV";

export const IMAGES = {
  heroBar: "https://images.unsplash.com/photo-1781955781178-6ea29c66e860?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  liveMusic: "https://images.unsplash.com/photo-1708689794188-8c72e8e70c4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  hookah: "https://images.unsplash.com/photo-1635547821500-77542481940c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktail: "https://images.pexels.com/photos/4485364/pexels-photo-4485364.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  storefront: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/plny7vwv_unnamed%20%282%29.webp",
  lounge: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/9fau3dmn_unnamed%20%281%29.webp",
};

// Guest-supplied dishes (gallery)
export const DISHES = [
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/dkbvujk7_IMG_1185.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/mz35h5hg_IMG_1188.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/345feb82_IMG_1195.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/pb4j725k_IMG_1197.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/ry7ifp7c_IMG_1192.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/yfifomoh_IMG_1198.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/eij5bbgr_IMG_1201.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/77pfzjch_IMG_1176.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/ig78x6nb_IMG_1177.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/0c7ov3mj_IMG_1179.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/8oiaqphj_IMG_1180.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/qr87fssv_IMG_1181.webp" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_luxury-table-reserve-5/artifacts/l3ra4bdj_IMG_1183.webp" },
];

// Full menu
export const MENU = [
  {
    id: "ethiopian",
    label: "Ethiopian",
    note: "Served with fresh injera.",
    items: [
      { name: "Tibs", price: "$18", desc: "Tender tips of marinated rib eye beef with peppers, onions, garlic and a touch of rosemary." },
      { name: "Awaze Tibs", price: "$18", desc: "Tender beef cubes sautéed with berbere sauce, rosemary, onions & green peppers." },
      { name: "Tibs Firfir", price: "$18", desc: "Tenderloin beef cooked in berbere sauce, tomato paste, garlic & spices, tossed with injera." },
      { name: "Kwanta Firfir (Dry Beef)", price: "$18", desc: "Dry beef with onion, jalapeño peppers and garlic, mixed with pieces of injera." },
      { name: "Shiro", price: "$15", desc: "Ground split peas simmered in a house spice blend." },
      { name: "Bozena Shiro", price: "$18", desc: "Ground beef and split peas simmered in a spice blend." },
      { name: "Yetsom Firfir", price: "$15", desc: "Injera soaked in spiced tomato, onion, green pepper and Ethiopian berbere." },
      { name: "Fish (ASSA) Dullet / Fish Goulash", price: "$18", desc: "Ground or cubed fish lightly fried in onion, tomato and our hot berbere, served with injera." },
      { name: "Spaghetti", price: "$14", desc: "Tomato sauce or meat sauce, served with a side salad." },
    ],
  },
  {
    id: "sandwiches",
    label: "Mains & Sandwiches",
    note: "All sandwiches served with fresh lettuce, tomato and a side of French fries.",
    items: [
      { name: "Cheeseburger", price: "$15", desc: "Char-grilled burger with your choice of cheese & pickle." },
      { name: "Chicken Wrap", price: "$15", desc: "Marinated chicken with cheddar, tomato, lettuce & pickle." },
      { name: "BBQ Chicken Wrap", price: "$15", desc: "Chicken breast with BBQ sauce, cheddar, lettuce & tomato." },
      { name: "Grilled Chicken Sandwich", price: "$15", desc: "Grilled chicken on a soft bun with your choice of cheese." },
      { name: "Buffalo Chicken Sandwich", price: "$15", desc: "Grilled chicken on a soft bun with cheese & buffalo sauce." },
      { name: "Cheesesteak", price: "$15", desc: "Thinly sliced ribeye, melted cheese & onion on a French roll." },
      { name: "Rice & Dry Beef (Derek Tibs)", price: "$18", desc: "Rice served with tenderloin dry Ethiopian-style marinated beef." },
      { name: "Grilled Chicken & Rice", price: "$17", desc: "Rice served with marinated grilled chicken breast." },
      { name: "Salmon", price: "$21", desc: "Grilled to perfection, lightly seasoned, served with rice & vegetables." },
      { name: "Tilapia", price: "$18", desc: "Two spice-crusted fillets with vegetables and your choice of rice or pasta." },
    ],
  },
  {
    id: "appetizers",
    label: "Appetizers",
    note: "",
    items: [
      { name: "Lentil or Chicken Samosa", price: "$6", desc: "Two pieces stuffed with lentil or chicken & special spices." },
      { name: "Spring Roll", price: "$6", desc: "Two pieces stuffed with mixed vegetables." },
      { name: "Onion Rings", price: "$8", desc: "Beer battered & served with ranch." },
      { name: "Fish & Chips", price: "$12", desc: "Tempura-battered cod, tartar & fries." },
      { name: "Crispy Chicken Tenders", price: "$12", desc: "Golden battered chicken with honey mustard & fries." },
      { name: "Jumbo Shrimp Tempura (4 pc)", price: "$12", desc: "Light & crispy deep-fried shrimp with dipping sauce." },
      { name: "Traditional Buffalo Wings", price: "$10 / $14", desc: "Super crispy in spicy sauce with celery, carrots & blue cheese. 6 pc $10 · 10 pc $14." },
    ],
  },
  {
    id: "salads",
    label: "Salads",
    note: "",
    items: [
      { name: "Grilled Chicken Caesar Salad", price: "$14", desc: "Grilled chicken, romaine, croutons, parmesan & Caesar dressing." },
      { name: "Caesar Salad", price: "$9", desc: "Romaine lettuce, croutons & parmesan." },
      { name: "House Salad", price: "$9", desc: "Garden fresh greens with lemon & vinaigrette dressing." },
    ],
  },
  {
    id: "cocktails",
    label: "Cocktails",
    note: "Happy Hour 5–8 PM · $12 each.",
    items: [
      { name: "Four Black Roses", price: "$12", desc: "Four Roses Bourbon, PAMA, Lemon, Simple Syrup." },
      { name: "Side Car", price: "$12", desc: "Remy Martin 1738 Cognac, Cointreau, Lemon, Simple Syrup." },
      { name: "Old Fashioned Prohibition", price: "$12", desc: "George Remus Bourbon, Bitters, Simple Syrup." },
      { name: "PB Espresso Martini", price: "$12", desc: "Skrewball Peanut Butter Whiskey, Finest Call Espresso, Carolan's Irish Cream." },
      { name: "Black Rose Punch", price: "$12", desc: "Mount Gay Black Barrel Rum, OJ, Pineapple, Grenadine." },
      { name: "Rum Punch", price: "$12", desc: "SelvaRey Coconut Rum, REAL Pineapple, Lime, Grenadine." },
      { name: "Cinnamon Apple Margarita", price: "$12", desc: "Corralejo Tequila, Cointreau, Apple Purée, Lemon, Cinnamon." },
      { name: "Gin & Jam", price: "$12", desc: "The Botanist Gin, Blackberry Purée, Q Club Soda." },
      { name: "Ruby Slipper", price: "$12", desc: "Deep Eddy Ruby Red Grapefruit Vodka, St. Elder Elderflower, Q Grapefruit Soda, Lime." },
      { name: "Lemon Drop", price: "$12", desc: "Deep Eddy Lemon Vodka, Simple Syrup, Lemon." },
      { name: "Hibiscus Mule", price: "$12", desc: "Chopin Vodka, Q Hibiscus Ginger Beer, Lime." },
    ],
  },
  {
    id: "hookah",
    label: "Hookah",
    note: "Prices subject to change.",
    items: [
      { name: "Head", price: "$11.99", desc: "Single hookah head, your choice of flavor." },
      { name: "Happy Hours Special", price: "$19.99", desc: "5:00 PM – 9:00 PM." },
    ],
    tags: ["Gum Mint", "Crème Mint", "Orange Mint", "Blue Mist", "Grape Mint", "Lady Killer", "Sex On The Beach", "Double Apple", "Peach", "Mango", "Kiwi", "Lemon", "Guava", "Cherry", "Pineapple", "Watermelon", "Blueberry", "BMW", "& many more"],
  },
  {
    id: "drinks",
    label: "Smoothies & Beers",
    note: "",
    items: [
      { name: "Berry Mix Smoothie", price: "$7", desc: "Fresh blended berries." },
      { name: "Mango & Pineapple Smoothie", price: "$7", desc: "Tropical fresh blend." },
    ],
    tags: ["Corona", "Becks", "Blue Moon", "Heineken", "Habesha", "Amstel", "Guinness", "Modelo", "Miller Lite", "Stella", "Bud Light", "Budweiser"],
  },
];
